module.exports = __webpack_public_path__ + "img/CRC1_Plasma.389f2be0.png";